const strings = {
  'howTo/hockeyChallenge/header/image/src': {
    en: '2025_tnhc_reversed_en.png',
    fr: '2025_tnhc_reversed_fr.png',
  },
  'howTo/hockeyChallenge/blurb/text': {
    en: ['Playing the Tims NHL Hockey', ' Challenge<sup>TM</sup> is as easy as 1-2-3!'],
    fr: ['Jouer au Défi de hockey de la LNH,', ' c’est simple comme bonjour!'],
  },
  'howTo/hockeyChallenge/blurb/button/text': {
    en: 'Make your picks',
    fr: 'Faites vos choix',
  },
  'howTo/hockeyChallenge/blurb/steps': {
    en: [
      'Choose 3 NHL players to score.',
      'Not sure who to pick? Choose Scout’s Picks to fill in players for you!',
      'Submit your picks, watch the games, and enjoy!',
      'After the games are done, check the leaderboard to see where you rank or your history to see how well you did.',
    ],
    fr: [
      'Choisissez 3 joueurs de la LNH qui marqueront un but.',
      'Vous ne savez pas trop quels joueurs choisir? Utilisez les choix des recruteurs et votre alignement sera déterminé pour vous!',
      'Soumettez vos choix, puis regardez les matchs et passez du bon temps!',
      'Après les matchs, consultez le classement pour connaître votre rang ou affichez votre historique pour voir vos résultats.',
    ],
  },
  'howTo/hockeyChallenge/steps/image/src': {
    en: ['gameinfo_steps_img1.png', 'gameinfo_steps_img2.png', 'gameinfo_steps_img3.png', 'gameinfo_steps_img4.png'],
    fr: ['gameinfo_steps_img1.png', 'gameinfo_steps_img2.png', 'gameinfo_steps_img3.png', 'gameinfo_steps_img4.png'],
  },
  'howTo/hockeyChallenge/blurb/text/line/1': {
    en: 'Choose 3 NHL players to score a goal and submit your picks.',
    fr: 'Choisissez 3 joueurs de la LNH qui marqueront un but et soumettez vos choix.',
  },
  'howTo/hockeyChallenge/blurb/text/line/2': {
    en: "It's as easy as 1-2-3.",
    fr: 'C’est aussi simple que cela!',
  },
  'howTo/hockeyChallenge/step/1/title/text': {
    en: 'Pick 3 NHL® players to score a goal',
    fr: 'Sélectionnez 3 joueurs de la LNH qui marqueront un but',
  },
  'howTo/hockeyChallenge/step/2/title/text': {
    en: 'Submit Your Picks!',
    fr: 'Soumettez vos choix!',
  },
  'howTo/hockeyChallenge/step/3/title/text': {
    en: 'If your NHL® players score, you score sweet prizes!',
    fr: 'Si vos joueurs de la LNH marquent un but, vous récoltez de délicieux prix!',
  },
};

export default strings;
